import api from '@/api/index.js'

const account_emails = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_ACCOUNT_EMAILS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_EMAILS: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_ACCOUNT_EMAILS_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    }
  },

  actions: {
    LoadAccountEmails({commit}, accountID) {
      commit('SET_ACCOUNT_EMAILS_ERROR', null)
      commit('SET_ACCOUNT_EMAILS_LOADING', true)
      return api.get(`accounts/${accountID}/emails?limit=150&offset=0`)
        .then((response) => {
          commit('SET_EMAILS', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_EMAILS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  },
}

export default account_emails
